<script setup lang="ts">
  import { computed } from 'vue';
  import { useRouter } from 'vue-router';
  import { Checkbox } from '@/shared/ui';
  import RecordActionsCell from './RecordActionsCell.vue';
  import type { DraftItem, RecordAction } from '../model/models.types';

  const props = withDefaults(
    defineProps<{
      draft: DraftItem;
      isSelected: boolean;
      canRename?: boolean;
      canDelete?: boolean;
    }>(),
    { canRename: false, canDelete: false }
  );

  const emit = defineEmits<{
    'toggle-selection': [id: number];
    rename: [draft: DraftItem];
    delete: [draft: DraftItem];
  }>();

  const hiddenActions = computed<RecordAction[]>(() => [
    ...(props.canRename ? [] : (['rename'] as RecordAction[])),
    ...(props.canDelete ? [] : (['delete'] as RecordAction[])),
  ]);

  const router = useRouter();

  function handleAction(action: RecordAction): void {
    if (action === 'view') {
      router.push({
        name: 'GestaoRegistrosRascunhoVisualizar',
        params: { id: props.draft.id },
      });
      return;
    }
    if (action === 'edit') {
      router.push({
        name: 'EditarFormulario',
        params: { id: String(props.draft.id) },
        query: { origem: 'rascunhos' },
      });
      return;
    }
    if (action === 'rename') {
      emit('rename', props.draft);
      return;
    }
    if (action === 'delete') {
      emit('delete', props.draft);
    }
  }
</script>

<template>
  <tr class="table-row-hover border-t border-gray-02 transition-colors duration-300 ease-out">
    <td class="pl-4 pr-2 py-4.5 align-middle leading-[0]">
      <Checkbox
        :id="draft.id"
        :checked="isSelected"
        @toggle="emit('toggle-selection', draft.id)"
      />
    </td>
    <!-- Registro -->
    <td class="py-4.5 text-sm text-gray-07 text-left align-middle whitespace-nowrap">
      {{ draft.registry }}
    </td>
    <!-- Título -->
    <td class="pl-6 py-4.5 text-sm text-gray-07 text-left align-middle whitespace-nowrap min-w-80">
      {{ draft.title }}
    </td>
    <!-- Data de salvamento -->
    <td class="pl-6 py-4.5 text-sm text-gray-07 text-left align-middle w-full whitespace-nowrap">
      {{ draft.savedDate }}
    </td>
    <!-- Ações -->
    <RecordActionsCell :hidden-actions="hiddenActions" @action="handleAction" />
  </tr>
</template>
